export default {
    pt:{
        body: {
            noMatch: "Desculpe, nenhum registro foi encontrado!",
            toolTip: "Ordenar",
            columnHeaderTooltip: column => `Ordenar por ${column.label}`
          },
          pagination: {
            next: "Próxima página",
            previous: "Página anterior",
            rowsPerPage: "Registros por página:",
            displayRows: "de",
          },
          toolbar: {
            search: "Busca",
            downloadCsv: "Download CSV",
            print: "Imprimir",
            viewColumns: "Visualizar colunas",
            filterTable: "Filtrar tabela",
          },
          filter: {
            all: "Todos",
            title: "Filtros",
            reset: "Reiniciar",
          },
          viewColumns: {
            title: "Mostrar colunas",
            titleAria: "Mostrar/Esconder colunas da tabela",
          },
          selectedRows: {
            text: "linha(s) selecionada",
            delete: "Apagar",
            deleteAria: "Apagar linhas selecionadas",
          },
    },
    en:{},
    es:{
        body: {
            noMatch: "Lo sentimos, no se encontró ningún registro.",
            toolTip: "Orden",
            columnHeaderTooltip: column => `Ordenar por ${column.label}`
          },
          pagination: {
            next: "Pagina siguiente",
            previous: "Pagina anterior",
            rowsPerPage: "Líneas por página:",
            displayRows: "de",
          },
          toolbar: {
            search: "Busca",
            downloadCsv: "Download CSV",
            print: "Imprimir",
            viewColumns: "Ver columnas",
            filterTable: "Filtrar tabela",
          },
          filter: {
            all: "Todos",
            title: "Filtros",
            reset: "Reiniciar",
          },
          viewColumns: {
            title: "Mostrar columnas",
            titleAria: "Mostrar/Esconder columnas de la tabla",
          },
          selectedRows: {
            text: "línea(s) seleccionada(s)",
            delete: "Eliminar",
            deleteAria: "Eliminar líneas seleccionadas",
          },
    },
};
